import React from 'react';
import ReactDOM from 'react-dom';
//import { render } from "react-snapshot";
import { Provider } from 'react-redux';
//import { PersistGate } from "redux-persist/integration/react";
import { BrowserRouter, Route } from 'react-router-dom';

import * as serviceWorker from 'serviceWorker';

import 'scss/main.scss';
import { App } from 'App';
import { Store } from 'state/Store';
import { Loader } from 'components/loader/Loader';
import { Alerts } from 'components/alerts/Alerts';
import { Notifications } from 'components/alerts/Notifications';
// import {
//   InstagramFetch,
//   InstagramFetchById,
// } from 'state/actions/user/InstagramInfoActions';

/**
 * 
  <Provider store={Store}>
    <PersistGate persistor={PersistedStore}>
      <BrowserRouter>
        <Route path={"*"} component={App}/>
      </BrowserRouter>

      <Loader/>

      <Alerts/>
      
      <Notifications/>
    </PersistGate>
  </Provider>

 */

ReactDOM.render(
  //render(
  <Provider store={Store}>
    <BrowserRouter>
      <>
        <Route path={'*'} component={App} />
        <Notifications />
      </>
    </BrowserRouter>

    <Loader />

    <Alerts />
  </Provider>,
  document.getElementById('gb-main')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
